/*
 * @Author: Teemo Ding
 * @Date: 2021-08-11 13:34:00
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-07 10:39:48
 * @FilePath: /unifyxp-v2-store-portal/src/pages/CustomerDatabaseConfig/CustomerDetails/RemarksTags/index.tsx
 */

import { Label, Select, Tag, TextArea } from '@/src/components/Antd';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { Icon } from '@/src/tools/icon';
import { Form } from 'antd';
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { isUserValid, storeResourceNameGenerator } from 'src/tools/getUserInfo';
import { i18nGet } from 'src/tools/tools';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from 'src/types/common/resources';
import css from '../css.module.less';

const permissions = () => {
  const edit_customer_info = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Customers,
        subCategory: EnumSubCategory.CustomerDetailsPage,
        operation: EnumOperation.edit_customer_info,
      }),
    ],
  });
  return {
    edit_customer_info,
  };
};

const RemarksTags = ({ type, availManualTags, autoTags }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { edit_customer_info } = permissions();
  const availManualTagOption = (availManualTags || []).map((tag) => ({
    label: tag.name,
    value: tag.uuid,
  }));

  return (
    <div className={css.itemBlock}>
      <SectionWrapper
        titleClassName={css.titleContainer}
        containerClassName={`${css.informationContainer} ${css.remarksContainer} ${css.wrapperContainer}`}
        title={getI18n('general.remarks')}>
        <Form.Item
          className={css.remarksTextArea}
          label={
            <Label
              title={
                type == 'Subscriber'
                  ? getI18n(
                      'customerDatabaseSetting.remarksTags.subscriberRemarks',
                    )
                  : getI18n(
                      'customerDatabaseSetting.remarksTags.customerRemarks',
                    )
              }
              textLength={500}
              nameKey={
                type == 'Subscriber'
                  ? getI18n('customerDatabaseSetting.remarksTags.remark')
                  : getI18n('customerDatabaseSetting.remarksTags.remarks')
              }
            />
          }
          labelCol={{
            span: 24,
          }}
          name={
            type == 'Subscriber'
              ? getI18n('customerDatabaseSetting.remarksTags.remark')
              : getI18n('customerDatabaseSetting.remarksTags.remarks')
          }>
          <TextArea
            size='large'
            maxLength={500}
            autoSize={{ minRows: 1, maxRows: 3 }}
            disabled={!edit_customer_info}
          />
        </Form.Item>
        {type !== 'Subscriber' && (
          <Form.Item
            label={
              <Label
                title={getI18n(
                  'customerDatabaseSetting.remarksTags.customerManualTags',
                )}
              />
            }
            labelCol={{
              span: 24,
            }}
            name='tagUuids'>
            <Select
              className={css.manualTagsSelect}
              getPopupContainer={(trigger) => trigger}
              mode='multiple'
              size='large'
              filterOption={(input, option) =>
                option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              placeholder={getI18n(
                'customerDatabaseSetting.remarksTags.searchandaddcustomermanualtag.',
              )}
              options={availManualTagOption}
              showArrow={true}
              suffixIcon={<Icon type='iconlanguageCopy' />}
              disabled={!edit_customer_info}></Select>
          </Form.Item>
        )}
        {type !== 'Subscriber' && (
          <Form.Item
            className={css.autoTags}
            label={
              <Label
                title={getI18n(
                  'customerDatabaseSetting.remarksTags.customerAutoTags',
                )}
              />
            }
            labelCol={{
              span: 24,
            }}>
            {(autoTags || []).map((tag, index) => (
              <Tag key={index}>{tag.name}</Tag>
            ))}
          </Form.Item>
        )}
      </SectionWrapper>
    </div>
  );
};

export default RemarksTags;
